import React from 'react';
import { Redirect } from 'react-router-dom';

const LogoutRoute: React.FC = () => <Redirect to="/" />;

export default LogoutRoute;
